var variantDictionary = {};
var productSubscription = null;
var productBottle = null;
var productCount = 0;
var productCountSubscription = 0;
for(var i in product.variants) {
  variantDictionary[product.variants[i].id] = product.variants[i];
  var variantTitle = product.variants[i].title.replace('All ', '');
  //@Todo: Remove before launch
  if(product.title.replace('Plant') !== product.title) {
    product.tags.push('plant');
  }
  if(variantTitle == 'Variety Pack - Assorted Flavors' && product.tags.indexOf('plant') > -1) {
    variantTitle = 'Variety Pack - Assorted Flavors Plant';
  }
  var variantSettings = productSettings[variantTitle];
  if(variantSettings) {
    var description = variantSettings.description;
    if(product.tags.indexOf('starter-pack') > -1) {
      if(variantSettings.descriptionStarterPack) {
        description = variantSettings.descriptionStarterPack;
      }
    }
    if(product.tags.indexOf('includes-green-bottle') > -1) {
      description += ' We also include our signature <a href="https://www.oatsovernight.com/products/oats-overnight-blenderbottle"><strong>Oats Overnight BlenderBottle®</strong></a> so you can enjoy your breakfast on the go.';
    }
    else if(product.tags.indexOf('includes-purple-bottle') > -1) { 
      description += ' We also include our signature <a href="https://www.oatsovernight.com/products/oats-overnight-blenderbottle-plant-based"><strong>Oats Overnight BlenderBottle®</strong></a> so you can enjoy your breakfast on the go.';
    }
    $('.variant-description[data-variant-id="' + product.variants[i].id + '"]').html(description);
    $('.product-display[data-variant-id="' + product.variants[i].id + '"] .bottle').attr('src', variantSettings.bottleImage);
  }
}
for(var i in product.tags) {
  if(product.tags[i].substr(0, 7) === 'amount-') {
    var amount = parseInt(product.tags[i].replace('amount-', ''));
    productCount = amount;
    productCountSubscription = 0;
    if(productCount === 12) {
      productCountSubscription = 13;
    }
    else if(productCount === 24) {
      productCountSubscription = 27;
    }
    else {
      productCountSubscription = productCount;
    }
  }
}
if(collectionProducts.length) {
  for(var i in collectionProducts) {
    if(collectionProducts[i].tags.indexOf('Subscription') > -1 || collectionProducts[i].tags.indexOf('subscription') > -1) {
      productSubscription = collectionProducts[i];
    }
    if(collectionProducts[i].tags.indexOf('bottle') > -1) {
      productBottle = collectionProducts[i];
    }
  }
}
function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

$(function() {
  $('.image').on('click', function(event) {
    $.magnificPopup.open({
      delegate: 'a',
      type: 'image',
      closeOnContentClick: false,
      closeBtnInside: false,
      mainClass: 'mfp-with-zoom mfp-img-mobile',
      image: {
        titleSrc: function() {
          return event.target.alt;
        }
      },
      items: {
        src: $(this).find('img').attr('src')
      }, type: 'image'
    });
  });
  if($('#productSelect').length > 0) {
    new Shopify.OptionSelectors('productSelect', {
      product: product,
      onVariantSelected: function(variant) {
        variantSelection(variant.id);
      },
      enableHistoryState: true
    });
  }

  var $flavorSelect = $('.flavor-pane select');
  $flavorSelect.on('change', function() {
    window.location.href = $(this).val();
  });

  $('.price-per-breakfast').html('$' + ((product.price / productCount) / 100).toFixed(2));
  if(productSubscription) {
    $('.price-per-breakfast-subscription').html('$' + ((productSubscription.price / productCountSubscription) / 100).toFixed(2));
  }

  var getProductPrice = function () {
    var frequency = $('.subscription-checkbox').hasClass('checked') ? 'monthly' : 'one-time'; //$('.interval.selected').attr('data-frequency');
    var hasBottle = $('.bottle-checkbox').is(':checked') || $('.include-bottle-checkbox').hasClass('checked');
    var totalPrice = 0;
    if(frequency === 'monthly') {
      totalPrice = productSubscription.price;
    } else {
      totalPrice = product.price;
    }
    return (totalPrice / 100).toFixed(2);
  };

  var calculateFinalPrice = function (price) {
    var variantId = $('.size.selected').attr('data-variant-id');
    var frequency = $('.frequency.selected').attr('data-frequency');
    var hasBottle = $('.bottle-checkbox').is(':checked') || $('.include-bottle-checkbox').hasClass('checked');
    var totalPrice = variantDictionary[variantId].price;
    var initialPrice = totalPrice;
    // if(price) {
    //   totalPrice = price;
    // } else {
    //   totalPrice = product.price;
    // }
    if(frequency === 'monthly') {
      totalPrice = totalPrice - (totalPrice * 0.10);
    } 
    // if(frequency === 'monthly') {
    //   $('.final-price-per-breakfast').html('$' + ((totalPrice / productCountSubscription) / 100).toFixed(2));
    // }
    // else {
    //   $('.final-price-per-breakfast').html('$' + ((totalPrice / productCount) / 100).toFixed(2));
    // }
    // if(hasBottle) {
    //   totalPrice += 600;
    // }
    $('.total-price').fadeOut(200, function() {
      if(frequency === 'monthly') {
        $('.total-price .saving-price').removeClass('hidden').text('$' + (initialPrice / 100).toFixed(2));
      }
      else {
        $('.total-price .saving-price').addClass('hidden');
      }
      $('.total-price .price').text('$' + (totalPrice / 100).toFixed(2));
      $('.total-price').fadeIn(200);
    });
  };

  var variantSelection = function (variantId) {
    $('.product-display, .flavor').removeClass('active');
    $('.product-display[data-variant-id="' + variantId + '"]').addClass('active');
    $('.product-flavors .flavor[data-variant-id="' + variantId + '"]').addClass('active');
    $('.product-name').text(variantDictionary[variantId].title);
    var selectBackground = "url('" + variantDictionary[variantId].featured_image.src + "'), linear-gradient(45deg, transparent 50%, #71A746 50%),linear-gradient(135deg, #71A746 50%, transparent 50%),linear-gradient(to right, #F7F7F7, #F7F7F7)";
    $('.single-option-selector').css('background-image', selectBackground);

    if(nonSubscribableVariants.indexOf(variantId) > -1) {
      $('.subscription-display').hide();  
      $('.subscription-not-available').show();
      if($('.subscription-checkbox').hasClass('checked')) {
        $('.subscription-checkbox').trigger('click');
      }
    }
    else {
      $('.subscription-display').show();
      $('.subscription-not-available').hide();
    }
  };

  // var frequencySelection = function (frequency) {
  //   $('.product-frequency').text(frequency === 'one-time' ? 'One Time Purchase' : 'Subscription');
  //   $('.interval').removeClass('selected');
  //   $('.interval[data-frequency="' + frequency + '"]').addClass('selected');
  //   calculateFinalPrice();
  // };
  
  var bottleSelection = function () {
    var isSelected = $('.bottle-checkbox').is(':checked') || $('.include-bottle-checkbox').hasClass('checked');
    if(isSelected) {
      $('.bottle-section').addClass('selected');
      $('.price-summary').css({ display: 'block' });
      if(!productBottle) {
        $('.product-image .bottle').css({display: 'inline-block'});
        $('.product-image .regular').css({display: 'none'});
      }
    }
    else {
      $('.bottle-section').removeClass('selected');
      $('.price-summary').css({ display: 'none' });
      if(!productBottle) {
        $('.product-image .bottle').css({display: 'none'});
        $('.product-image .regular').css({display: 'inline-block'});
      }
    }
    calculateFinalPrice();
  };

  var sizeSelection = function (variantId) {
    $('.sizes-section .size').removeClass('selected');
    $('.sizes-section .size[data-variant-id="' + variantId + '"]').addClass('selected');
    $('.product-display, .flavor').removeClass('active');
    $('.product-display[data-variant-id="' + variantId + '"]').addClass('active');
    calculateFinalPrice(variantDictionary[variantId].price);
    if(variantDictionary[variantId].title == "Starter Pack") {
      $('.starter-pack-extra').show();
    } else {
      $('.starter-pack-extra').hide();
    }
  };

  var showNutritionLabels = function (variantName) {
    if(variantName.substr(0, 4) === 'All ') {
      variantName = variantName.substr(4);
    }
    // if(variantName == 'Dairy-Free Variety Pack') {
    //   variantName = 'Variety Pack - Assorted Flavors Plant';
    // }
    // if(variantName == 'Dairy-Free Variety Pack') {
    //   variantName = 'Variety Pack - Assorted Flavors Plant';
    // }
    var html = buildNutritionHtml(productSettings[variantName]);
    $('.nutrition-popup .body').html(html);
    $('.nutrition-popup, .nutrition-popup-fade').addClass('active');
    $('body').css({ overflow: 'hidden' });

    $('.nutrition-popup .multi-nutrition-container').each(function() {
      var tabpanes = $(this).find('.nutrition-information');
      $(tabpanes[0]).addClass('active');
      var tabs = $('.nutrition-popup .nutrition-information-tab');
      for(var i = 0; i < tabs.length; i++) {
        $(tabs[i]).attr('data-pos-id', i).on('click', function() {
          $('.nutrition-popup .multi-nutrition-container .nutrition-information').removeClass('active');
          $(tabpanes[$(this).attr('data-pos-id')]).addClass('active');
          if($(window).width() <= 425) {
            $('.tab-container').css({ 'display': 'none' });
            $('.nutrition-popup .header .nutrition-title').addClass('hidden');
            $('.nutrition-popup .header .nutrition-back').removeClass('hidden');
          }
        });
      }
    });
    $('.nutrition-popup .header .nutrition-back').on('click', function() {
      $('.tab-container').css({ 'display': 'flex' });
      $('.nutrition-popup .header .nutrition-title').removeClass('hidden');
      $('.nutrition-popup .header .nutrition-back').addClass('hidden');
    });

    $('.close-nutrition-popup, .nutrition-popup-fade').unbind('click').on('click', function () {
      $('.nutrition-popup, .nutrition-popup-fade').removeClass('active');
      $('body').css({ 'overflow-y': 'auto' });   
    });
  };

  $('.nutritional-button-container .btn').on('click', function () {
    showNutritionLabels(product.title);
  });
  $('.nutrtition-button').each(function () {
    var variantName = $(this).attr('data-title');
    if(variantName.substr(0, 4) === 'All ') {
      variantName = variantName.substr(4);
    }
    if(variantName == 'Variety Pack - Assorted Flavors' && product.tags.indexOf('plant') > -1) {
      variantName = 'Variety Pack - Assorted Flavors Plant';
    }
    if(!productSettings[variantName]) {
      $(this).hide();
      
    }
  });

  // region add-to-cart
  var getCorrespondingVariant = function (correspondingProduct) {
    var variantId = $('#productSelect').val();
    // var variantId = $('.product-flavors .flavor.active').attr('data-variant-id');
    for(var i in correspondingProduct.variants) {
      if(correspondingProduct.variants[i].title === variantDictionary[variantId].title) {
        return correspondingProduct.variants[i].id;
      }
    }
  };

  var performAjaxCart = function (data, callback) {
    $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: data,
        success: function(lineItem) {

          // Pinterest Tracking
          // pintrk('track', 'addtocart', {
          //     value: 0,
          //     order_quantity: 1,
          //     currency: 'USD'
          // });
          // End Pinterest Tracking

          if(typeof callback === 'function') {
            callback();
          }
          else {
            theme.RightDrawer.open();
          }
        },
        error: function(XMLHttpRequest, textStatus) {
        }
      });
  };
  var bottleRelayBugCheck = false;
  var addToCartNew = function() {
    var data = {
      quantity: 1
    };
    
    /* Get size variant */
    if($('.sizes-section .size').length) {
      var variantId = $('.sizes-section .size.selected').attr('data-variant-id');
      data.id = variantId;
    }
    
    var frequency = $('.frequency-section .frequency.selected').attr('data-frequency');
    if(frequency === 'monthly') {
      data.id = subscriptionVariants[variantId];
      data.properties = {
        shipping_interval_frequency: 30,
        shipping_interval_unit_type: 'Days',
        subscription_id: 228143
      };
    }
    performAjaxCart(data);

    
  }
  var addToCart = function() {
    var data = {
      quantity: 1
    };

    if($('.sizes-section .size').length) {
      var variantId = $('.sizes-section .size.selected').attr('data-variant-id');
      data.id = variantId;
      performAjaxCart(data);
    }
    else if($('#productSelect').length > 0) {//$('.product-flavors .flavor').length) {
      if($('.interval-section .interval').length || $('.new-interval-section').length) {
        // var frequency = $('.interval-section .interval.selected').attr('data-frequency');
        var frequency = $('.subscription-checkbox').hasClass('checked') ? 'monthly' : 'one-time';
        
        if(frequency === 'one-time') {
          if($('.bottle-checkbox').is(':checked') || $('.include-bottle-checkbox').hasClass('checked')) {
            // check if this product has a bottled product in its collection
            if(productBottle) {
              var variantId = getCorrespondingVariant(productBottle);
              data.id = variantId;
              performAjaxCart(data);
            }
            // if it doesn't we'll add it separately
            else {
              var variantId = $('#productSelect').val();
              data.id = variantId;

              bottleRelayBugCheck = true;
              performAjaxCart(data, function () {
                if(!bottleRelayBugCheck) {
                  return; 
                }
                bottleRelayBugCheck = false;
                var bottleData = {
                  quantity: 1
                };
                if(product.tags.includes('plant')) {
                  bottleData.id = productBottlePlantId;
                }
                else {
                  bottleData.id = productBottleClassicId;
                }
                performAjaxCart(bottleData);
              });
            }
          }
          else {
            var variantId = $('#productSelect').val();
            // var variantId = $('.product-flavors .flavor.active').attr('data-variant-id');
            data.id = variantId;
            performAjaxCart(data);
          }
        }
        else if(frequency === 'monthly') {
          var variantId = getCorrespondingVariant(productSubscription);
          data.id = variantId;
          data.properties = {
            shipping_interval_frequency: 30,
            shipping_interval_unit_type: 'Days'
          };
          bottleRelayBugCheck = true;
          performAjaxCart(data, function () {
            if(!bottleRelayBugCheck) {
              return; 
            }
            bottleRelayBugCheck = false;
            if($('.bottle-checkbox').is(':checked') || $('.include-bottle-checkbox').hasClass('checked')) {
              var bottleData = {
                quantity: 1
              }; 
              if(product.tags.indexOf('plant') > -1) {
                bottleData.id = productBottlePlantId;
              }
              else {
                bottleData.id = productBottleClassicId;
              }
              performAjaxCart(bottleData);
            }
            else {
              theme.showCart('#ajaxcart');
              theme.RightDrawer.open();
            }
          });
        }
      }
      else {
        var variantId = $('#productSelect').val();
        //var variantId = $('.product-flavors .flavor.active').attr('data-variant-id');
        data.id = variantId;
        performAjaxCart(data);
      }
    }
    else {
      data.id = product.variants[0].id;
      performAjaxCart(data);
    }
  };
  function eventHandler(event, selector) {
    event.stopPropagation(); // Stop event bubbling.
    event.preventDefault(); // Prevent default behaviour
    if (event.type === 'touchend') selector.off('click'); // If event type was touch turn off clicks to prevent phantom clicks.
}
  $('button.add-to-cart').on('click', function (event) {
    // eventHandler(event, $(this));
    // if (dragging)
    //   return;
    addToCartNew();
  });
  // .unbind('touchend').on('touchend', function () {
  //   addToCart();
  // });
  // endregion

  // region select size 
  $('.sizes-section .size').on('click', function () {
    var variantId = $(this).attr('data-variant-id');
    sizeSelection(variantId);
  });
  // endregion

  // region select size 
  $('.frequency-section .frequency').on('click', function () {
    frequencySelection($(this).data('frequency'));
  });
  // endregion

  var frequencySelection = function(frequency) {
    $('.frequency-section .frequency').removeClass('selected');
    $('.frequency-section .frequency[data-frequency="' + frequency + '"]').addClass('selected');
    $('.sizes-section').removeClass('subscription');
    if(frequency == 'monthly') {
      $('.sizes-section').addClass('subscription');
    }
    calculateFinalPrice();
  };

  // region select bottle 
  $('.oats-checkbox').on('click', function () {
    var checked = $('.bottle-checkbox').is(':checked');
    $('.bottle-checkbox').prop('checked', !checked).trigger('change');
    
  });
  $('.bottle-checkbox').on('change', function () {
    if($(this).is(":checked")) {
      $('.oats-checkbox').addClass('checked');
    }
    else {
      $('.oats-checkbox').removeClass('checked');
    }
    bottleSelection();
  });
  $('.new-interval-section').on('click', function(e) {
    if(!$(e.target).hasClass('dark-checkbox') && !$(e.target).hasClass('info-button')) {
      var changeCheckedClass = $(this).find('.dark-checkbox').hasClass('checked')
      changeCheckedClass ? $(this).find('.dark-checkbox').removeClass('checked') : $(this).find('.dark-checkbox').addClass('checked');
    }
  });
  $('.dark-checkbox').on('click', function(e) {
    var changeCheckedClass = $(this).hasClass('checked');
    changeCheckedClass ? $(this).removeClass('checked') : $(this).addClass('checked');
  });
  $('.include-bottle-checkbox').on('click', function() {
    bottleSelection();
  });
  $('.subscription-checkbox').on('click', function() {
    var frequency = $(this).hasClass('checked') ? 'monthly' : 'one-time';
    frequencySelection(frequency);
  });
  $('.bottle-section').on('click', function(e) {
    if(!$(e.target).hasClass('bottle-checkbox') && !$(e.target).hasClass('oats-checkbox') && !$(e.target).parent().hasClass('column-question-mark')) {
      if(!$('.bottle-checkbox').is(':checked')) {
        $('.bottle-checkbox').prop('checked', true).trigger('change');
      }
    }
  });
  $('.column-question-mark').on('click', function () {
    var position = $(this).offset();
    $('.tooltip-bottle').css({
      top: position.top,
      left: position.left - 315,
      display: 'block'
    });
    $('.tooltip-popup-fade').addClass('active');
    $('.close-tooltip, .tooltip-popup-fade').unbind('click').on('click', function () {
      $('.tooltip-bottle').css({ display: 'none' });
      $('.tooltip-popup-fade').removeClass('active');
    });
  });

  $('img.free-bottle, .bottle-message').on('click', function () {
    var position = $(this).offset();
    var bottleTooltipCss = {
      top: position.top,
      left: position.left - 315,
      display: 'block'
    };
    if($(window).width() <= 425) {
      bottleTooltipCss.left = '50%';
      bottleTooltipCss.top = '50%';
      bottleTooltipCss.marginLeft = '-' + ($('.tooltip-free-bottle').width() / 2) + 'px';
      bottleTooltipCss.marginTop = '-' + ($('.tooltip-free-bottle').height() / 2) + 'px';
      bottleTooltipCss.position = 'fixed';
    }
    $('.tooltip-free-bottle').css(bottleTooltipCss);
    $('.tooltip-popup-fade').addClass('active');
    $('.close-tooltip, .tooltip-popup-fade').unbind('click').on('click', function () {
      $('.tooltip-free-bottle').css({ display: 'none' });
      $('.tooltip-popup-fade').removeClass('active');
    });
  });
  // endregion

  // region select frequency 
  $('.interval[data-frequency]').on('click', function(e) {
    if(!$(e.target).hasClass('question-mark')) {
      var frequency = $(this).attr('data-frequency');
      frequencySelection(frequency);
    }
  });
  $('.subscription-info-button, .interval .question-mark').on('click', function (e) {
    e.preventDefault();
    var position = $(this).offset();
    var left = position.left - 315;
    left = left < 10 ? 10 : left;
    $('.tooltip-subscription').css({
      top: position.top,
      left: left,
      display: 'block'
    });
    $('.tooltip-popup-fade').addClass('active');
    $('.close-tooltip, .tooltip-popup-fade').unbind('click').on('click', function () {
      $('.tooltip-subscription').css({ display: 'none' });
      $('.tooltip-popup-fade').removeClass('active');
    });
  });
  // endregion

  // region flavor-selector
  $('.product-flavors .flavor').on('click', function() {
    var variantId = $(this).attr('data-variant-id');
    variantSelection(variantId);
  });
  // endregion

  var initialVariantId = $('.product-flavors .flavor.active').attr('data-variant-id');
  if(initialVariantId) {
    variantSelection($('.product-flavors .flavor.active').attr('data-variant-id'));
  }
  if($_GET && $_GET['variant']) {
    if(variantDictionary[$_GET['variant']]) {
      sizeSelection($_GET['variant']);
    }
  }
  calculateFinalPrice();
});

$(function() {
  function getCartCount(){
    $.ajax({
        url: '/cart.js',
        dataType: 'json',
        type: 'get',
      	cache : false,
        success: function(data) {
          $('#CartDrawerB .CartCount').text(data.item_count);
        },
        error: function(XMLHttpRequest, textStatus) {
          console.log(XMLHttpRequest);
        }
    });
  }

  getCartCount();
});


$(function() {
  $('.image-scroller').each(function() {
    var $this = $(this);
    var $container = $this.find('.image-scroller-container');
    var $stretcher = $this.find('.image-stretcher');
    var $images = $stretcher.find('.image');
    var $thumbnails = $this.find('.selector-thumbnail');

    var imageWidth = $container.width();

    $stretcher.css({
      'width': ((imageWidth + 20) * $images.length) + 'px'
    });

    $images.css({ width: imageWidth + 'px' });

    var position = 0;

    var generateMarginIndex = function(counter) {
      return (0 - (imageWidth * counter) - (counter * 5)) ;
    };

    var scrollToPosition = function(counter) {
      position = counter;
      marginIndex = generateMarginIndex(position);
      $stretcher.stop().animate({ marginLeft: marginIndex + 'px' }, 300);
      if(position == $images.length - 1) {
        $this.find('.arrow-right').css({'display': 'none'});
      }
      else {
        $this.find('.arrow-right').css({'display': 'inline-block'});
      }
      if(position == 0) {
        $this.find('.arrow-left').css({'display': 'none'});
      }
      else {
        $this.find('.arrow-left').css({'display': 'inline-block'});
      }
      $($thumbnails).removeClass('active');
      $($thumbnails[position]).addClass('active');
    }

    var scrollRight = function() {

      if(position >= $images.length - 1) {
        return;
      }
      scrollToPosition(position + 1);
    };
    var scrollLeft = function() {
      if(position <= 0) {
        return;
      }
      scrollToPosition(position - 1);
    };

    $this.find('.arrow-left').on('click', scrollLeft);
    $this.find('.arrow-right').on('click', scrollRight);

    var mc = new Hammer($stretcher[0]);
    // mc.on('swipeleft', scrollRight); //swapped for natural scrolling
    // mc.on('swiperight', scrollLeft);
    mc.get('pan').set({
      touchAction: 'auto',
      recognizers: [
          [Hammer.Pan,{ direction: Hammer.DIRECTION_HORIZONTAL }],
      ]
    });
    var timer = null;
    mc.on("panleft panright panup pandown tap press", function(ev) {
      // console.log(ev.type +" gesture detected.");
      clearTimeout(timer);
      timer = setTimeout(function() {
        if(ev.type == 'panleft') {
          scrollRight();
        }
        if(ev.type == 'panright') {
          scrollLeft();
        }
      }, 20);
    });

    $thumbnails.each(function(i) {
      $(this).on('click', function() {
        scrollToPosition(i);
      });
    });
  });

  var defaultSize = getUrlParameter('size');
  var subscription = getUrlParameter('subscription');
  if(defaultSize) {
    console.log('.size-block[data-size="'+defaultSize+'"] .size');
    $('.size-block[data-size="'+defaultSize+'"] .size').trigger('click');
  }
  if(subscription) {
    $('.frequency[data-frequency="monthly"]').trigger('click');
  }
});
$(function () {
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
        $(".flavor-pane").addClass("safari");
    }
});